var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import get from 'lodash/get';
var handler = {
    get: function (target, key) {
        if (key === '__path')
            return target.join('.');
        return new Proxy(__spreadArray(__spreadArray([], target, true), [key], false), handler);
    },
};
export var asTypeProxy = function () {
    return new Proxy([], handler);
};
var makePath = function (typeProxy) {
    return typeProxy.__path;
};
export function makePathModel(rawPaths) {
    var knownPaths = Object.keys(rawPaths);
    var paths = knownPaths.reduce(function (acc, key) {
        acc[key] = makePath(rawPaths[key]);
        return acc;
    }, {});
    var selectors = knownPaths.reduce(function (acc, key) {
        acc[key] = function (values) { return get(values, paths[key]); };
        return acc;
    }, {});
    return [paths, selectors];
}
/* eslint-enable @typescript-eslint/no-explicit-any */
